export default __webpack_public_path__ + "static/media/delete.5dfd10e9.svg";